import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { PaymentManagement } from '../modal';

export default function reducer(state: PaymentManagement = new PaymentManagement(),
  action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.PAYMENT_MANAGEMENT_LIST_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.PAYMENT_MANAGEMENT_LIST_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.PAYMENT_MANAGEMENT_LIST_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
